import { Component, Input, OnInit } from '@angular/core';
import { PageElementViewModel, ConferenceViewModel, ExhibitDesignerViewModel, SponsorshipLandingPageViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ConferenceCMSService, ExhibitService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-conference-exhibit-listing',
  templateUrl: 'conference-exhibit-listing.component.html',
})
export class ConferenceExhibitListingComponent implements OnInit {
  initialized = false;
  @Input() conference: ConferenceViewModel;
  @Input() element: PageElementViewModel;
  exhibits: SponsorshipLandingPageViewModel[];

  constructor(private exhibitsService: ConferenceCMSService, public auth: AuthenticationService) {}

  ngOnInit(): void {
    this.exhibitsService.getLandingPagesForAllSponsorsAndExhibits(this.conference.id).subscribe((exhibits) => {
      this.exhibits = exhibits;
      this.initialized = true;
    });
  }
}
